import { render, staticRenderFns } from "./MediaGalleryList.vue?vue&type=template&id=500b77e2"
import script from "./MediaGalleryList.vue?vue&type=script&lang=js"
export * from "./MediaGalleryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports